import { LOCALES } from "common/constants";
import React from "react";

const FeaturesDescription = ({ t }) => {
  return (
    <>
      <section className="insurance redirect" id="insurance">
        <div className="container">
          <div className="row">
            <div className="insurance-group">
              <h2 className="pb-0">{t("PRELIMINARY INVOICES")}</h2>
              <p className="first">
                {t(
                  "With our feature, you can easily send a preliminary invoice to your client for approval before finalizing the actual invoice. This step ensures that your client can review and approve the details regarding the total amount and the services provided in advance. Once your client has approved the preliminary invoice, you will receive an email prompting you to send the final invoice. You also have the option to download the preliminary invoice in PDF format for manual sending. Remember, after receiving your client's approval, you must send an invoice to them."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="invoice-root redirect" id="invoicing">
        <div className="container">
          <div className="row text-right">
            <div className="insurance-group">
              <h2 className="pb-0">
                {t("INVOICING WITH ROOT AND RUT DEDUCTION")}
              </h2>
              <p className="first">
                {t(
                  "If you carry out work in crafts, repairs or other services that qualify for RUT and ROT deductions, we have good news for you. With Invozio, you can easily invoice your private customers and offer them the opportunity to deduct up to 50% of the cost of the work performed through RUT and ROT deductions."
                )}
              </p>
              <p>
                {t(
                  "The RUT deduction applies to services related to household work, such as cleaning, gardening or babysitting. By offering the RUT deduction to your private customers, your services become more financially advantageous for them and can increase their interest in hiring you."
                )}
              </p>
              <p>
                {t(
                  "The ROT deduction, on the other hand, applies to renovation, rebuilding and extension work in private residences. By offering the ROT deduction, you can make it more attractive for your private customers to carry out larger projects and save money at the same time."
                )}
              </p>
              <p>
                {t(
                  "Note that the RUT and ROT deductions only apply to private customers and not to invoicing to companies."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="request-payment redirect" id="request_express">
        <div className="container">
          <div className="row">
            <div className="insurance-group">
              <h2 className="pb-0">{t("Request express payment")}</h2>
              <p className="first">
                {t(
                  "Need your money urgently? With Invozio, you can request express payment and have your funds paid out within just two days. This is ideal for quick liquidity and avoiding long payment wait times."
                )}
                .
              </p>
              <p>
                {t(
                  "For express payment, a fee of 5.9% of the invoice amount is applied. Additionally, if this fee does not reach 590 SEK, a minimum fee of 590 SEK is charged. We conduct a credit check on both you, the invoice issuer, and your customer to ensure fast and secure payment."
                )}
              </p>
              <p>
                {t(
                  "Express payment is a convenient way to access your funds swiftly. It's available for approved invoices, subject to certain conditions based on your invoicing history and the customer's creditworthiness."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="holidays redirect" id="set_aside">
        <div className="container">
          <div className="row">
            <div className="insurance-group">
              <h2 className="pb-0">{t("Set aside holiday allowance")}</h2>
              <p className="first">
                {t(
                  "As a freelancer, it's important to take responsibility for your own finances, including making sure you have enough money to cover vacation periods."
                )}
              </p>
              <p>
                {t(
                  "With Invozio, you can easily set aside between 0-50% of your earnings in holiday compensation, which gives you security and financial stability during your holidays."
                )}
              </p>
              <p>
                {t(
                  "By making regular deposits into your holiday pay, you can be sure you have money to withdraw when you need to take time off and enjoy some well-deserved rest. We give you the flexibility to choose the amount that best suits your finances and needs."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="collective-invoice redirect" id="invite_others">
        <div>
          <div className="container">
            <div className="row text-right">
              <div className="insurance-group">
                <h2 className="pb-0">
                  {t("Invite other freelancers and send a collective invoice")}
                </h2>
                <p className="first">
                  {t(
                    "Now you can easily invoice together with other freelancers who work for the same client. By inviting your colleagues to our platform, you can easily coordinate your invoices and get paid separately for each of you."
                  )}
                </p>
                <p>
                  {t(
                    "This is perfect when you work together on a project or share tasks for the same client. You avoid the hassle of collecting and distributing money manually. Instead, our platform takes care of all the administrative stuff for you."
                  )}
                </p>
                <p>
                  {t(
                    "Here's how it works: You create an invoice for the work you've done and invite your colleagues who have also contributed to the project. Each of you will then receive a separate payment for the work you have invoiced."
                  )}
                </p>
                <p>
                  {t(
                    "This gives you simplicity, clarity and smoother handling of your payments. You can focus on your work and let us take care of the administration."
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="invoice-currencies redirect"
        id="invoicing_different_countries"
      >
        <div className="container">
          <div className="row">
            <div className="insurance-group">
              <h2 className="pb-0">{t("Invoice in different currencies")}</h2>
              <p className="first">
                {t(
                  "At Invozio, we offer you the option of invoicing in various currencies, including Swedish kronor (SEK), US dollars (USD), Euros (EUR), British pounds (GBP), Swiss Franc (CHF), Canadian Dollar (CAD), Australian Dollar (AUD), Norwegian Krone (NOK), Danish Krone (DKK),Japanese Yen (JPY) and Chinese Yuan (CNY). We understand that as a freelancer you may have clients and projects all over the world, and therefore we want to give you the flexibility to invoice in the currency that best suits your collaboration."
                )}
              </p>
              <p>
                {t(
                  "When you create an invoice in a currency other than SEK, we make sure to convert the amount into Swedish kronor upon payment. We use the current daily exchange rate to ensure that you receive the correct compensation for your work."
                )}
              </p>
              <p>
                {t(
                  "Being able to invoice in different currencies gives you the opportunity to work with international clients without having to worry about exchange fees or complicated conversion processes. It's a way to do business globally while keeping your invoicing simple and smooth."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="vat-rate redirect" id="change_vat_rate">
        <div className="container">
          <div className="row text-right">
            <div className="insurance-group">
              <h2 className="pb-0">{t("Change the VAT rate")}</h2>
              <p className="first">
                {t(
                  "At Invozio, we understand that VAT rates can vary depending on the type of service or product you are invoicing for. Therefore, we give you the option to easily change the VAT rate in your invoice if it deviates from the standard VAT rate of 25%."
                )}
              </p>
              <p>
                {t(
                  "In our invoicing tool, you can easily choose between different VAT rates, including 0%, 6%, 12% and 25%. This means that you can adapt the VAT rate according to the rules and requirements that apply to your particular service or product."
                )}
              </p>
              <p>
                {t(
                  "Whether you are invoicing for VAT-exempt services, reduced VAT rates or standard VAT, you can easily change the VAT rate in the invoice to ensure correct handling of VAT in your business."
                )}
              </p>
              <p>
                {t(
                  "Being able to adjust the VAT rate in the invoice gives you flexibility and simplifies your bookkeeping and VAT reporting. You can be safe in the knowledge that VAT is handled correctly and in accordance with applicable rules and regulations."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="credit-invoice redirect" id="create_credit_invoice">
        <div className="container">
          <div className="row">
            <div className="insurance-group">
              <h2 className="pb-0">
                {t("Create credit invoice free of charge")}
              </h2>
              <p className="first">
                {t(
                  "Do you need to correct an invoice or refund part of the amount? With our simple and user-friendly tool, you can create credit invoices easily and free of charge."
                )}
              </p>
              <p>
                {t(
                  "We understand that changes and adjustments may sometimes be necessary, and with our credit invoice feature you can do this without putting a strain on your wallet."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="salary-paid redirect" id="have_salary">
        <div className="container">
          <div className="row text-right">
            <div className="insurance-group">
              <h2 className="pb-0">
                {t("Have salary paid to a foreign bank account")}
              </h2>
              <p className="first">
                {t(
                  "With Invozio, you can have your salary paid to a foreign bank account that has an IBAN number. A fee may be added depending on the bank and country."
                )}
              </p>
              <p>
                {t(
                  "At Invozio, we understand that our users may be spread all over the world and need the possibility to have their salary paid to a foreign bank account. That's why we offer you this flexibility and the opportunity to receive your salary directly to your foreign bank account that has an IBAN number."
                )}
              </p>
              <p>
                {t(
                  "Getting your salary paid into your foreign bank account is easy and convenient. You only need to enter your bank account's IBAN number in our system and we will ensure that your salary reaches your bank account shortly. This saves you time and money on international transfer costs and makes it easy for you to manage your finances, no matter where you are in the world."
                )}
              </p>
              <p>
                {t(
                  "Important to note is that there may be a fee for international bank transfers depending on your bank and the country where your bank account is registered. Fees may vary, but we always strive to keep them as low as possible for the convenience of our users."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="agreements-and-quotes redirect" id="write_agreements">
        <div className="container">
          <div className="row">
            <div className="insurance-group">
              <h2 className="pb-0">
                {t("Write agreements and create quotes")}
              </h2>
              <p className="first">
                {t(
                  "As a freelancer, it is crucial to have the right documentation in place to ensure a smooth business relationship with your clients. With Invozio, you can easily create and adapt agreements and quotes using our professional templates."
                )}
              </p>
              <p>
                {t(
                  "Our user-friendly interface makes it easy to create and customize contracts and quotes that fit your specific needs. You can quickly fill in relevant information, including price, terms and delivery times, and then generate professional documents that give a serious and reliable impression."
                )}
              </p>
              <p>
                {t(
                  "Whether you need to write an agreement to ensure clear terms with your customer or create a quote to present your work and pricing in a convincing way, the tools and templates are available to you at Invozio."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="register-expenses redirect" id="time_reports">
        <div className="container">
          <div className="row text-right">
            <div className="insurance-group">
              <h2 className="pb-0">
                {t("Time reports and register expenses")}
              </h2>
              <p className="first">
                {t(
                  "At Invozio, we offer you a simple and flexible solution to time report your hours worked and register your expenses. We understand the importance of having control over your work effort and being able to invoice for any costs you have incurred in connection with your work."
                )}
              </p>
              <p>
                {t(
                  "With our invoicing tool, you can easily log in and register your hours on different projects or assignments. You have a full overview of how much time you have spent on each activity, which facilitates invoicing and gives you a clear picture of your work effort."
                )}
              </p>
              <p>
                {t(
                  "In addition, you can easily register your expenses in the system. Whether it's travel, purchasing materials or other costs related to your work, you can easily document and invoice them to your customers."
                )}
              </p>
              <p>
                {t(
                  "Being able to report time and register expenses in our invoicing tool not only makes it easier for you to keep track of your time and costs, but it also gives you increased professionalism towards your customers. You can clearly report and invoice for the time and expenses you have put into your work."
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="agreements-and-quotes redirect" id="faster_salary">
        <div className="container">
          <div className="row">
            <div className="insurance-group">
              <h2 className="pb-0">
                {t("GET PAID FASTER WITH REVOLUT")}
              </h2>
              <p className="first">
               <span>
                {t("Enjoy quicker salary payments when you link a Revolut account. Don’t have one?")}</span> <span>  <a
                  href="https://revolut.com/referral/?referral-code=kevindtxd!JUN1-25-AR-H2&geo-redirect"
                  target="_blank"
                  rel="noopener noreferrer"
                   style={{textDecoration: "underline"}}
                > {t("Sign up here")} </a></span>  <span>{t("and start benefiting today.")}</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="my-4 pb-0 about">
        <div className="container container-dynamic">
          <div
            className="trustpilot-widget"
            data-locale={LOCALES.SV_SE}
            data-template-id="5406e65db0d04a09e042d5fc"
            data-businessunit-id="64f712e3dbd20bbfcf3a825f"
            data-style-height="28px"
            data-style-width="100%"
            data-theme="light"
          >
            <a
              href="https://se.trustpilot.com/review/invozio.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeaturesDescription;